import Enum from '/@/modules/core/app/helpers/Enum';

export default class Locale extends Enum {
  key!: string;
  value!: string;
  currency!: string;

  abr!: string;

  static ENGLISH: Locale = {
    key: 'en',
    value: 'English',
    currency: 'en-US',
    abr: 'EN'
  };

  static FRENCH: Locale = {
    key: 'fr-CA',
    value: 'Français',
    currency: 'fr-FR',
    abr: 'FR'
  };

  static FRENCH_QC: Locale = {
    key: 'fr-u-sd-caqc',
    value: 'Français Canadien',
    currency: 'fr-FR',
    abr: ''
  };

  static ENGLISH_QC: Locale = {
    key: 'en-u-sd-caqc',
    value: 'Canadian English',
    currency: 'en-US',
    abr: ''
  };

  static getAllowedLocales(): Locale[] {
    return [Locale.ENGLISH, Locale.FRENCH];
  }
}
